import { makeStyles } from '@material-ui/core';
import {
  IconButton,
  Card,
  CardContent,
  Typography,
  Switch,
  Stack,
  Box,
} from '@mui/material';
import { useIsMobileDevice } from "~/hooks/useIsMobileDevice";
import { useEffect, useRef, useState } from 'react';

import { trackZoneOutlinesToggled } from '~/analytics/fns';
import Icon from '~/components/Icon';
import { I18n } from '~/i18n';
import { useAppDispatch, useAppSelector } from '~/redux-rtk';
import { AppActions } from '~/redux-rtk/slices/appSlice';

const useStyles = makeStyles((theme: any) => ({
  bottomRightControls: {
    zIndex: 1,
    position: 'absolute',
    gap: '10px',
    'align-items': 'flex-start',
    width: 'max-content',
    height: '30px',
    right: '0px',
    bottom: '20px',
    pointerEvents: 'none',
  },
}));

export const LayerToggle = (props: {}) => {
  const { bottomRightControls } = useStyles();
  const [openLayerToggle, setOpenLayerToggle] = useState(false);
  const dispatch = useAppDispatch();
  const showNormalEvacZones = useAppSelector(
    state => state.app.data.showNormalEvacZones,
  );

  const cardRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const isMobile = useIsMobileDevice();

  const handleClickOutside = (event: MouseEvent) => {
    // when user clicks outside the popover and IconButton(it has it's own onClick to toggle popover), -
    // - the popover should get closed
    if (
      openLayerToggle &&
      cardRef.current &&
      !cardRef.current.contains(event.target as Node) &&
      !buttonRef.current.contains(event.target as Node)
    ) {
      setOpenLayerToggle(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openLayerToggle]);

  const PopoverStyle = isMobile ? {
    right: '0',
    width: '80vw',
    bottom: '40px'

  } : {
    right: '45px',
    bottom: '-50px',
    width: 'max-content',
  }
  const handleToggle = () => {
    trackZoneOutlinesToggled(!showNormalEvacZones);
    dispatch(AppActions.toggleShowNormalEvacZones(!showNormalEvacZones));
  };

  return (
    <Box sx={{ position: 'relative', width: 'max-content' }}>
      <IconButton
        onClick={e => {
          e.stopPropagation();
          setOpenLayerToggle(state => !state);
        }}
        title={I18n.t('map.layers')}
        autoFocus
        aria-label={I18n.t('map.zoneOutlines')}
        ref={buttonRef}
        sx={{
          padding: '8px',
          '& .sb-icon-div': {
            display: 'contents',
          },
        }}
      >
        <Icon name="Layers" color="black" size={15} isDecorative />
      </IconButton>
      {openLayerToggle && (
        <Card
          ref={cardRef}
          sx={{
            display: 'inline-block',
            position: 'absolute',
            maxWidth: '400px',
            borderRadius: 2,
            boxShadow: 3,
            padding: 1,
            ...PopoverStyle
          }}
        >
          <CardContent sx={{ paddingBottom: '16px !important' }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Icon name="Layers" color="black" size={15} />
                <Box>
                  <Typography variant="subtitle1" fontWeight={500}>
                    {I18n.t('map.zoneOutlines')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {I18n.t('map.showOutlines')}
                  </Typography>
                </Box>
              </Box>
              <Switch
                aria-label={I18n.t('map.ariaLabel.toggleLayer')}
                checked={showNormalEvacZones}
                onChange={handleToggle}
                color="primary"
              />
            </Stack>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};
